import { useState } from "react";

export default function Full90Deal() {
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <section id="full90" className="relative py-0 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/95a954d3088d7ffe167bca6563b623c3.jpg"
          alt="Sports bar background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/88 via-black/75 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-28 flex flex-col lg:flex-row items-center gap-16">
        {/* Left content */}
        <div className="flex-1 text-center lg:text-left">
          <div className="flex items-center gap-3 justify-center lg:justify-start mb-6">
            <span className="w-8 h-px bg-[#e8c34a]"></span>
            <span className="text-[#e8c34a] text-xs uppercase tracking-[0.35em] font-bold">
              Exclusive Deal
            </span>
            <span className="w-8 h-px bg-[#e8c34a]"></span>
          </div>

          <h2 className="text-white font-black text-6xl md:text-8xl uppercase leading-none mb-4">
            The
            <br />
            <span className="text-[#e8c34a]">Full 90</span>
          </h2>

          <p className="text-white/60 text-lg font-light mb-8 max-w-lg mx-auto lg:mx-0 leading-relaxed">
            Unlimited beers &amp; mimosas for just{" "}
            <span className="text-white font-bold">$30 per game.</span> Drink all 90 minutes, halftime included. Simply ask your server when you&apos;re seated and they&apos;ll get you set up.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-10">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-5 py-3">
              <i className="ri-beer-line text-[#e8c34a] text-2xl w-8 h-8 flex items-center justify-center"></i>
              <div className="text-left">
                <p className="text-white font-bold text-sm">Unlimited Beers</p>
                <p className="text-white/50 text-xs">All game long</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-5 py-3">
              <i className="ri-goblet-line text-[#e8c34a] text-2xl w-8 h-8 flex items-center justify-center"></i>
              <div className="text-left">
                <p className="text-white font-bold text-sm">Unlimited Mimosas</p>
                <p className="text-white/50 text-xs">Every drop, every minute</p>
              </div>
            </div>
          </div>

          <a
            href="#schedule"
            className="inline-flex items-center gap-3 bg-[#e8c34a] text-black font-black px-10 py-5 rounded-full uppercase tracking-widest text-sm hover:bg-[#f0d060] transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-black/20 rounded-full">
              <i className="ri-calendar-line text-base"></i>
            </span>
            View Game Schedule
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>

        {/* Right price card */}
        <div className="flex-shrink-0">
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-10 text-center min-w-[280px]">
            <p className="text-[#e8c34a] text-xs uppercase tracking-[0.35em] font-bold mb-4">
              Per Game
            </p>
            <p className="text-white font-black text-8xl leading-none mb-2">$30</p>
            <p className="text-white/50 text-sm mb-8">One flat rate, zero limits</p>

            <div className="flex flex-col gap-3 text-left mb-8">
              {[
                "Unlimited draft beers",
                "Unlimited mimosas",
                "Valid for entire 90 min match",
                "Halftime service included",
                "Add it on with your server",
              ].map((item) => (
                <div key={item} className="flex items-center gap-2.5">
                  <i className="ri-check-double-line text-[#e8c34a] text-sm flex-shrink-0"></i>
                  <span className="text-white/70 text-sm">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center gap-2 w-full bg-white/10 border border-white/20 text-white/80 py-4 rounded-xl text-sm text-center leading-snug px-4">
              <i className="ri-information-line text-[#e8c34a] flex-shrink-0 text-base"></i>
              Ask your server to add The Full 90 when you arrive
            </div>
          </div>
        </div>
      </div>

      {/* Terms & Conditions */}
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5">
          <button
            onClick={() => setTermsOpen((prev) => !prev)}
            className="flex items-center gap-2 text-white/40 hover:text-white/70 transition-colors cursor-pointer text-xs uppercase tracking-widest font-semibold whitespace-nowrap"
          >
            <i className="ri-shield-check-line text-sm"></i>
            The Full 90 — Terms &amp; Conditions
            <i className={`ri-arrow-down-s-line text-sm transition-transform duration-300 ${termsOpen ? "rotate-180" : ""}`}></i>
          </button>

          {termsOpen && (
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3 text-white/45 text-xs leading-relaxed pb-4">
              {[
                {
                  icon: "ri-user-follow-line",
                  text: "Must be 21+ with valid government-issued ID to participate. ID will be checked by your server before the package is activated.",
                },
                {
                  icon: "ri-time-line",
                  text: "The Full 90 is valid for the duration of one (1) scheduled match only, including halftime. Service ends at the final whistle.",
                },
                {
                  icon: "ri-walk-line",
                  text: "Management and staff reserve the right to discontinue service to any guest at any time, for any reason, without refund. We serve responsibly.",
                },
                {
                  icon: "ri-goblet-line",
                  text: "Package covers draft beers and mimosas only. Spirits, cocktails, wine, and bottled beverages are not included and will be charged separately.",
                },
                {
                  icon: "ri-refresh-line",
                  text: "Drinks are served at a pace determined by staff. We do not allow stockpiling or collecting multiple drinks at once.",
                },
                {
                  icon: "ri-team-line",
                  text: "The Full 90 package is per person. It cannot be shared, transferred, or split between guests.",
                },
                {
                  icon: "ri-bank-card-line",
                  text: "Payment is collected at the time of activation. Non-refundable once service has begun.",
                },
              ].map(({ icon, text }) => (
                <div key={text} className="flex items-start gap-2.5">
                  <i className={`${icon} text-[#e8c34a]/60 flex-shrink-0 mt-0.5`}></i>
                  <span>{text}</span>
                </div>
              ))}

              <div className="md:col-span-2 mt-3 pt-3 border-t border-white/10 text-white/30 italic">
                By purchasing The Full 90, you agree to these terms and acknowledge that violations may result in immediate termination of service without refund. We appreciate your cooperation in keeping the experience great for everyone.
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
